/* Shared by the header bell and the dashboard: the bell navigates to
   DASHBOARD_PATH with `state.scrollTo` set to a section id, and the
   dashboard scrolls that section into view once it has rendered. */
export const DASHBOARD_PATH = "/advanceDashboard";
export const NOTIFICATIONS_SECTION_ID = "dashboard-notifications";
